export default function () {
  /* 表格列头：统一 min-width，剩余宽度按内容长度比例分配，整行铺满不右侧留白 */
  return [
    { label: "序号", type: "index", width: 70 },
    { label: "订单编号", prop: "orderNumber", minWidth: 160 },
    { label: "产品名称", prop: "productType", minWidth: 140 },
    { label: "订单状态", prop: "status", slots: "status", minWidth: 100 },
    { label: "金额", prop: "money", slots: "money", minWidth: 90 },
    { label: "手机号", prop: "phone", slots: "phone", minWidth: 120 },
    { label: "openid", prop: "openid", slots: "openid", minWidth: 200 },
    { label: "下单备注", prop: "message", slots: "message", minWidth: 180 },
    { label: "订单创建时间", prop: "createTime", slots: "createTime", minWidth: 170 },
    { label: "支付成功时间", prop: "paySuccessTime", slots: "paySuccessTime", minWidth: 170 },
    { label: "商户单号", prop: "out_trade_no", slots: "outTradeNo", minWidth: 200 },
    { label: "交易单号", prop: "transaction_id", slots: "transactionId", minWidth: 180 },
    { label: "物流单号", prop: "logistics_num", slots: "logisticsNum", minWidth: 140 },
    {
      label: "操作",
      prop: "operation",
      minWidth: 100,
      slots: "operation",
    },
  ];
}
